import React from 'react';
import { LayoutGrid, Battery, Home, Activity, Coins, MonitorCheck } from 'lucide-react';
import { capabilities } from '../../data/mock';

const iconMap = {
  LayoutGrid: LayoutGrid,
  Battery: Battery,
  Home: Home,
  Activity: Activity,
  Coins: Coins,
  MonitorCheck: MonitorCheck
};

const CapabilitiesSection = () => {
  return (
    <section id="capabilities" className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-cyan-50 text-cyan-700 text-xs sm:text-sm font-medium mb-3 sm:mb-4 border border-cyan-200">
            Was wir konkret machen
          </span>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-slate-800 mb-3 sm:mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-sm sm:text-base text-slate-600 max-w-2xl mx-auto px-4">
            Alles aus einer Hand – von der Idee bis zum laufenden Betrieb.
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6">
          {capabilities.map((capability, index) => {
            const Icon = iconMap[capability.icon];
            return (
              <div 
                key={index}
                className="group p-4 sm:p-6 rounded-xl bg-slate-50 border border-slate-200 hover:border-cyan-300 hover:shadow-sm transition-all"
              >
                {/* Icon */}
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-cyan-50 border border-cyan-200 flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-cyan-100 transition-colors">
                  <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-cyan-700" />
                </div>
                
                <h3 className="text-sm sm:text-base font-semibold text-slate-800 mb-1 sm:mb-2 leading-tight">{capability.title}</h3>
                <p className="text-xs sm:text-sm text-slate-600 leading-relaxed hidden sm:block">{capability.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
